import React, { Component } from 'react';
import './skip.css';

class Skip extends Component {
  render() {
    return (
      <div id="skip-link" tabIndex="-1">
        <a  tabIndex="0" href="#main" className="element-invisible element-focusable">Skip to main content</a>
      </div>
    );
  }
} 

export default Skip;

